<template>
  <b-list-group>
    <b-list-group-item v-for="offer in offers" :key="offer.id" @click="$emit('click', offer)">
      <div class="d-flex justify-content-between">
        <div class="mr-auto">
          <div>{{ offer.gli }}</div>
        </div>

        <div class="text-right">
                        <span class="h6 mb-0">
                            {{ offer.quantity }}
                            @
                            {{ offer.is_native_currency ? '$' : '' }}{{ offer.offer_amount_native }} <span
                            class="text-muted pl-1"> {{ offer.currency }}</span>
                        </span>
          <div class="font-italic text-body text-muted">
            <template v-if="offer.status == 'P'">
              Expires
              in {{ offer.expire_time | timediff }}
            </template>
            <template v-else>

              <span v-b-tooltip.hover :title="offer.result_at">{{ offer.result_at | timediff }}</span>
              by
              <span v-b-tooltip.hover :title="offer.result_by_user.name">{{
                  offer.result_by_user.userid
                }}</span>
            </template>

          </div>
        </div>
      </div>

      <div class="py-1">
        <div>By: {{ offer.from }}</div>
        <div>{{ offer.model_description }}</div>
        <div class="font-italic">{{ offer.seller_message ? 'Seller: ' : '' }}{{ offer.seller_message }}</div>
        <div class="font-italic">{{ offer.buyer_message ? 'Buyer: ' : '' }}{{ offer.buyer_message }}</div>
      </div>

      <div class="d-flex flex-wrap">
        <div class="my-auto mr-auto">
          <offer-pill :offer="offer"/>
        </div>
      </div>
    </b-list-group-item>
  </b-list-group>
</template>

<script>
import OfferPill from "./offer-pill.vue";

export default {
  name: "offer-history",
  components: {OfferPill},
  props: {
    offers: Array,
  },
}
</script>

<style scoped>

</style>